const t = {
  "guests--content": "styles-module__guests--content___T94fX"
};
export {
  t as default
};
